import { useMemo } from "react"
import { organizationApi } from "@/api/client/organization"

interface UseOrganizationOptionsParams {
  enabled?: boolean
}

export function useOrganizationOptions({ enabled = true }: UseOrganizationOptionsParams = {}) {
  const { data, isPending, isError, refetch } = organizationApi.useOrganizationList({
    query: { enabled },
  })

  const options = useMemo(
    () =>
      (data?.organizations ?? []).map((organization) => ({
        value: organization.id,
        label: organization.name,
      })),
    [data]
  )

  return { options, isPending: enabled && isPending, isError, refetch }
}
